exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.payment-method .option-choice-name {\n  max-width: 100% !important;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/checkout/PaymentMethodControl.vue"],"names":[],"mappings":";AAAA;EACE,2BAA2B;CAAE","file":"PaymentMethodControl.vue","sourcesContent":[".payment-method .option-choice-name {\n  max-width: 100% !important; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ee542bf","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/PaymentMethodControl.vue
// module id = NcGi
// module chunks = 18